import { Plugins } from '@leverege/plugin'

const EvaluatorFactory = Plugins.createFactory( 'ConditionEvaluator', { 
  pluginKey : 'evaluator', strategy : Plugins.ALL 
} )

const AsyncEvaluatorFactory = Plugins.createFactory( 'AsyncConditionEvaluator', { 
  pluginKey : 'evaluator', strategy : Plugins.ALL 
} )

const ConditionFactory = Plugins.createFactory( 'Condition', { 
  pluginKey : 'condition', 
  strategy : Plugins.LOOKUP 
} )

export {
  EvaluatorFactory,
  AsyncEvaluatorFactory,
  ConditionFactory
}
